
import React, { useState } from 'react'

const MobileMenu = ({
  products,
  user,
  building_materials,
  services,
  careers,
  sustainability,
  about_us,
  social_links,
  no_background = false,
  graniterock_logo,
  icons = {}
}) => {
  const [ open, setOpen ] = useState(false)
  const [ selectedSubMenu, setSelectedSubMenu ] = useState(null)
  const toggleMenu = () => {
    setOpen(!open)
    setSelectedSubMenu(null)
  }
  const links = [
    {
      name: "Graniterock Supply",
      link: "/products/building-materials",
      subMenu: (building_materials||[]).map(x=>{
        return {
          name: x.name || x.title,
          link: x.name ? "/products/" + x.slug : "/product/" + x.slug
        }
      })
    },
    {
      name:"Products",
      link:"/products",
      subMenu: (products||[])
        .filter(x => !/Tech Notes|Natural Stone|Building Materials/.test(x.name))
        .map(x=> {
          return {
            name: x.name,
            link: x.path
          }
        })
        .concat([{ name: "Tech Notes", link: "/technical_reports" }])
    },
    {
      name: "Services",
      link: "/services",
      subMenu: services
    },
    {
      name: "Construction",
      link: "/projects",
    },
    {
      name: "Locations",
      link: "/locations",
    },
    {
      name:"Careers",
      link:"/careers",
      subMenu: careers
    },
    {
      name: "Community",
      link: "/community",
    },
    {
      name: "Sustainability",
      link: "/sustainability",
      subMenu: sustainability
    },
    {
      name: "About Us",
      link: "/about-us",
      subMenu: about_us
    }
  ].map(x=>{
    x.root = true
    return x
  })

  const renderLinks = () => {
    const usingLinks = selectedSubMenu ? links.find(link => link.name === selectedSubMenu).subMenu : links
    return usingLinks.map(link => {
      return (
        <li
          className={`mobile-menu-2025-link ${link.root ? "page-root" : ""} ${link.subMenu ? "mobile-menu-has-dropdown-submenu" : ""} ${selectedSubMenu ? "mobile-menu-has-dropdown-submenu-item" : ""}`}
          onClick={() => {
            if(link.subMenu) {
              setSelectedSubMenu(link.name)
            }else {
              window.location = link.link
            }
          }}
        >
          <div className="mobile-menu-2025-link-text">
          {link.name}
          </div>
          {link.subMenu && (
            <img src={icons.arrow} className="mobile-menu-2025-has-dropdown-submenu-arrow"/>
          )}
        </li>
      )
    })
  }

  const renderSearchForm = () => {
    return (
      <div
        role="button"
        aria-label="Search Graniterock Button"
        className="mobile-menu-2025-footer-search"
        onClick={() => window.location = "/search"}

      >
        <img alt="Search Graniterock" src={icons.search}/>
        SEARCH GRANITEROCK
      </div>
    )
  }

  const renderSocials = () => {
    const renderedSocialLinks =  social_links.map(x => {
      return (
        <a
          class={x.className}
          href={x.url}
          target="_blank"
        >
          <img src={x.image} alt={x.name} />
        </a>
      )
    })

    return (
      <div class="mobile-header-2025-social-media">
        <div class="mobile-header-2025-social-media-icons">
          {renderedSocialLinks}
        </div>
      </div>
    )
  }



  const renderSubMenuReturnLink = () => {
    if(selectedSubMenu) {
      return (
        <li
          className="mobile-menu-2025-link mobile-menu-submenu-return-link"
          onClick={() => setSelectedSubMenu(null)}
        >
          <img alt="Return arrow" src={icons.arrow} className="mobile-menu-2025-has-dropdown-submenu-arrow"/>
          <div className="mobile-menu-2025-link-text">
            {selectedSubMenu}
          </div>
         
        </li>
      )
    }
  }
  return (
    <>
      <div className="container hidden-md hidden-lg hidden-xl">
        <div className="col-md-12">
          <div class={`navbar-header navbar-2025-layout mobile-navbar-2025-layout ${no_background && "mobile-navbar-2025-no-background"}`}>
            <a class="navbar-brand" href="/">
              <img alt="Graniterock logo"
                src={graniterock_logo}
              />
            </a>

            <button onClick={toggleMenu} class="navbar-toggle collapsed" id="mobile-menu-button-2025" type="button">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
          </div>
        </div>
      </div>
      <div class={`mobile-menu-2025 ${open ? 'open' : 'closed'}`}>
        <div className="container h-full">
          <div className="col-md-12 mobile-menu-2025-inner h-full">
            <ul>
              {renderSubMenuReturnLink()}
              {renderLinks()}
            </ul>
            <div className="mobile-menu-2025-footer-spacer"/>
            <div className="mobile-menu-2025-footer">
              {renderSearchForm()}
              {renderSocials()}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MobileMenu